// src/shared-components/cards/components/ArtworkSliderCardSmall.jsx
import ArtworkImage from "./ArtworkImage";

import "./styles/ArtworkSliderCardSmall.css";

export default function ArtworkSliderCardSmall({ artworkData, onClick }) {
  return (
    <div className="artwork-card-small__container" onClick={onClick}>
      <ArtworkImage
        artworkData={artworkData}
        image={artworkData.artwork_media.artwork_main_picture.image_id}
        imageClassName="artwork-card-small__image"
        imageTemplateClassName="artwork-card-small__image"
      />
    </div>
  );
}
